<template>
  <header class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item" />
      <div class="buttons">
        <RouterLink
          class="button is-success is-outlined"
          active-class="is-active"
          :to="{ name: 'SignUp' }"
        >
          regístrate
        </RouterLink>
        <RouterLink
          class="button is-primary is-outlined is-inverted"
          active-class="is-active"
          :to="{ name: 'SignIn' }"
        >
          inicia sesión
        </RouterLink>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheNavbar',
};
</script>

<style scoped>
.navbar-brand {
  justify-content: space-between;
  width: 100%;
}

img.logo  {
  height: 48px;
  width: auto;
}

.buttons {
  padding: 0 .5rem;
  margin: 0;
}

.buttons .button {
  margin-bottom: 0;
}
</style>

<style>
.landing.hero.is-primary .navbar-item:hover {
  background-color: transparent;
}
</style>
